import { render, staticRenderFns } from "./HostingServices.vue?vue&type=template&id=45edd79c&"
import script from "./HostingServices.vue?vue&type=script&lang=js&"
export * from "./HostingServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45edd79c')) {
      api.createRecord('45edd79c', component.options)
    } else {
      api.reload('45edd79c', component.options)
    }
    module.hot.accept("./HostingServices.vue?vue&type=template&id=45edd79c&", function () {
      api.rerender('45edd79c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/ServicesPage/HostingServices.vue"
export default component.exports